// extracted by mini-css-extract-plugin
module.exports = {"container":"Slider_container__jMMDB","img":"Slider_img__15_o-","active":"Slider_active__3zTMP"};